import {RedeemIcon} from '@common/icons/material/Redeem';
import {Trans} from '@common/i18n/trans';
import {useSettings} from '@common/core/settings/use-settings';
import {useValidateTrialCode} from '@common/billing/trials/trial-requests';
import {usePendingTrial} from '@common/billing/trials/pending-trial';
import {arabicDayCount} from '@common/billing/trials/arabic-day-count';

// the same answer the offer bar already fetched is reused
const NOTE_STALE_TIME = 10 * 60 * 1000;

/**
 * Reminds a visitor who arrived with a free-trial code why they are creating
 * an account. Renders nothing for anyone without a valid remembered code, so
 * the sign-up page is unchanged for them.
 */
export function TrialSignupNote() {
  const {billing} = useSettings();
  const pending = usePendingTrial();
  const enabled = !!billing?.enable && !!billing?.trial_codes?.enable;
  const {data} = useValidateTrialCode(
    enabled && pending ? pending.code : null,
    {staleTime: NOTE_STALE_TIME},
  );

  if (!data?.valid || !data.trial_days) return null;

  return (
    <div
      role="note"
      // the text is Arabic also on the English site
      dir="auto"
      className="mb-20 flex items-center gap-10 rounded-xl border border-primary/30 bg-primary/5 px-12 py-10"
    >
      <RedeemIcon className="flex-shrink-0 text-primary" size="md" />
      <div className="min-w-0">
        <div className="text-sm font-bold text-primary">
          <Trans message="سجّل الآن وابدأ تجربتك المجانية" />
        </div>
        <div className="text-xs text-muted">
          <Trans
            message=":days مجاناً بدون بطاقة بنكية"
            values={{days: arabicDayCount(data.trial_days)}}
          />
        </div>
      </div>
    </div>
  );
}
